var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5c-3.364 0-6 2.582-6 5.878 0 1.605.642 3.552 1.636 4.963l.101.144C8.33 13.323 9 14.273 9 15a.75.75 0 1 0 1.5 0c0-1.204-.816-2.36-1.537-3.38l-.1-.143C8.046 10.321 7.5 8.674 7.5 7.378 7.5 4.924 9.477 3 12 3c2.523 0 4.5 1.924 4.5 4.378 0 1.295-.547 2.943-1.362 4.1l-.095.134c-.615.866-1.543 2.175-1.543 3.388a.75.75 0 1 0 1.5 0c0-.735.824-1.897 1.266-2.521l.096-.138C17.358 10.93 18 8.983 18 7.378 18 4.082 15.364 1.5 12 1.5Zm.163 6c-.347.06-.38 2.396-.56 3.284-.362-.5-.416-1.321-.747-1.388-.252 0-.386.8-.527 1.277l-1.237.186c-.59.23 1.771.291 1.905.299.252.634.693 1.978.874 1.485l.37-2.478c.377.783.512 1.873.7 1.873.245-.007.276-.499.457-1.059.637-.007 1.676-.015 1.598-.291 0 0-1.559-.097-1.953-.254-.095-.418-.518-2.964-.88-2.934ZM9.75 17.25A.752.752 0 0 0 9 18c0 .413.338.75.75.75h4.5c.412 0 .75-.337.75-.75a.752.752 0 0 0-.75-.75h-4.5Zm.75 3a.752.752 0 0 0-.75.75c0 .413.338.75.75.75h3c.412 0 .75-.337.75-.75a.752.752 0 0 0-.75-.75h-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.bfecdf19346b3e692e42627c9285d24f.svg";
export { ForwardRef as ReactComponent };